import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GuidedIntakePromoBanner'

export default defineMessages({
  bannerText: {
    id: `${scope}.bannerText`,
    defaultMessage: 'Build requests faster with Guided Intake.',
  },
  learnMore: {
    id: `${scope}.learnMore`,
    defaultMessage: 'Learn more',
  },
  dismissAriaLabel: {
    id: `${scope}.dismissAriaLabel`,
    defaultMessage: 'Dismiss the Guided Intake promotion',
  },
})
